/**
 * table form
 */
import React from 'react';

// import styles from './index.module.scss';

const Index = (props) => {
  return <div className="pms-table-form-container">{props.children}</div>;
};

export default Index;
